import BaseClient from './BaseClient';

class AdminOrgUnitsClient extends BaseClient {
    listOrgUnits(params) {
        const url = `/api/admin/org-units`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    createOrgUnit(teamId, data) {
        const url = `/api/admin/teams/${teamId}/org-units`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    favoriteOrgUnit(teamId, orgUnitId) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/favorite`;
        return this.makeCoreApiRequest(url, 'post');
    }

    deleteFavoriteOrgUnit(teamId, orgUnitId) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/favorite`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getHubspotCompanyId(teamId, orgUnitId) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/hubspot-company-id`;
        return this.makeCoreApiRequest(url, 'get');
    }

    updateHubspotCompanyId(teamId, orgUnitId, data) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/hubspot-company-id`;
        return this.makeCoreApiRequest(url, 'patch', data);
    }

    enableBilling(teamId, orgUnitId) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/billing-enable`;
        return this.makeCoreApiRequest(url, 'post');
    }

    updateBillingOptions(teamId, orgUnitId, data) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/billing-options`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    getPricing(teamId, orgUnitId) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/pricing`;
        return this.makeCoreApiRequest(url, 'get');
    }

    setPricing(teamId, orgUnitId, data) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/pricing`;
        return this.makeCoreApiRequest(url, 'put', data);
    }
}

export default new AdminOrgUnitsClient();
